import { FormattedMessage } from "react-intl";
import { Heading, Skeleton } from "@lendcord/concord";

const ADDRESS_TYPE_COUNT = 3;

// Mirrors AddressesSection's per-type bordered card shape (badge + button row,
// two text lines) while `addresses` is still loading.
export function AddressesSectionSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <Heading level={3}>
        <FormattedMessage id="lender.profile.addressesHeading" />
      </Heading>
      <div className="flex flex-col gap-4">
        {Array.from({ length: ADDRESS_TYPE_COUNT }, (_, index) => (
          <div key={index} className="rounded-md border border-border p-4">
            <div className="flex items-start justify-between gap-3">
              <Skeleton variant="rect" className="h-5 w-20" />
              <Skeleton variant="rect" className="h-5 w-14" />
            </div>
            <Skeleton variant="text" className="mt-3 h-5 w-full max-w-xs" />
            <Skeleton variant="text" className="mt-1.5 h-4 w-40" />
          </div>
        ))}
      </div>
    </div>
  );
}
